export const AwfUserRoleId = {
  awfExternalConsultant: 'consultantQuoteDetails.consultants',
  awfContractor: 'finalReview.reviewer',
  awfInternalConsultant: 'finalReview.internalConsultantReviewer',
};
